const colorMap = {
  debug: "rgba(230,230,230)",
  warn: "orange",
  error: "#F8616A",
};

export const defaultHandler = ({ level, name, args }) => {
  console[level](`[${name}]`, ...args);
};

class HTMLHandler {
  #logList;

  constructor() {
    this.#logList = [];
  }

  handle = ({ level, name, args, timestamp }) => {
    this.#logList.push({
      level,
      name,
      args,
      timestamp,
    });
  };

  #prettyFormatLog({ level, name, args, timestamp }) {
    const date = new Date(timestamp);
    const time = date.toLocaleTimeString();
    const dateStr = date.toLocaleDateString();
    return `${time} ${dateStr} [${level
      .toUpperCase()
      .padEnd(5, " ")}] [${name}] ${args
      .map(this.#prettyFormatValue)
      .map(this.#escapeHTML)
      .join(", ")}`.replaceAll("\n", "<br>");
  }

  #prettyFormatValue(value) {
    if (value instanceof Error) return value.toString();
    if (typeof value == "object") return JSON.stringify(value, null, 2);
    return value;
  }

  #escapeHTML(html) {
    const tempDiv = document.createElement("div");
    tempDiv.textContent = html;
    return tempDiv.innerHTML;
  }

  prettyFormatLogs() {
    return this.#logList.map(({ level, name, timestamp, args }) => {
      return `<span style='background-color: ${
        colorMap[level]
      }'>${this.#prettyFormatLog({ level, name, args, timestamp })}</span>`;
    });
  }
}

export const htmlHandler = new HTMLHandler();

export class Logger {
  static #handlers = __DEV__ || __ADMIN__ ? [defaultHandler] : [];

  constructor(name) {
    this.name = name;
  }

  static addHandler(handler) {
    Logger.#handlers.push(handler);
  }

  runHandlers(level, ...args) {
    const timestamp = Date.now();
    for (const handler of Logger.#handlers)
      handler({ level, name: this.name, args, timestamp });
  }

  debug(...args) {
    this.runHandlers("debug", ...args);
  }

  info(...args) {
    this.runHandlers("info", ...args);
  }

  log(...args) {
    this.info(...args);
  }

  warn(...args) {
    this.runHandlers("warn", ...args);
  }

  error(...args) {
    this.runHandlers("error", ...args);
  }

  assert(condition, ...args) {
    if (!condition) this.error(...args);
  }
}

export function getLogger(name) {
  return new Logger(name);
}

if (__DEV__) window.Logger = Logger;
